import React, { FC } from 'react';
import { QueryClient, QueryClientProvider as BaseQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { ToastControllerProvider } from '../toast';

import { createTestQueryClient } from './TestQueryClientProvider';

const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  },
});

const isTest = () => HC_ENV_NODE_ENV === 'test' || Boolean(window?.Cypress);
export const getQueryClient = () => {
  const isTestLocal = isTest();
  return isTestLocal ? createTestQueryClient() : defaultQueryClient;
};

export const QueryClientProvider: FC = ({ children }) => {
  return (
    <BaseQueryClientProvider client={getQueryClient()}>
      <ToastControllerProvider>{children}</ToastControllerProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </BaseQueryClientProvider>
  );
};
